const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const YourMedias = (state = INITIAL_STATE, action) => {
  
  switch (action.type) {
    case "YOUR_MEDIAS_REQUEST":
      return { loading: true, error: false, data: [] };
    case "YOUR_MEDIAS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "YOUR_MEDIAS_ERROR":
      return { loading: false, error: true, data: action.payload };
    default:
      return state;
  }

};

export default YourMedias;
